// extracted by mini-css-extract-plugin
export default {"action-button":"FormWarehouseIn_action-button__8oIxx","form-action":"FormWarehouseIn_form-action__Pb-Zy"};